<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import i18n from '@/plugins/i18n'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'
import { useStudentStore } from '@/stores/student'
import { useSwitchStudentMutation } from '@/composable/queries/Dara/student'

const appStore = useAppStore()
const authStore = useAuthStore()
const studentStore = useStudentStore()
const { t } = useI18n()

const saving = computed(() => switchStudentMutation.isPending.value)

const switchStudentMutation = useSwitchStudentMutation()

const selectStudent = (studentId: number) => {
  switchStudentMutation.mutate(studentId, {
    onSuccess: () => {
      authStore.getLoggedInUser().then(() => {
        appStore.studentSetCurrentStudentModal = false
        appStore.setSnackbar({
          colour: 'success',
          text: t('components.student.set_current_student.success'),
        })
      })
    }
  })
}
// Auto-open/close modal based on setCurrentStudentRequired flag
watch(() => studentStore.setCurrentStudentRequired, (required) => {
  if (required && !studentStore.is_trial) {
    appStore.studentSetCurrentStudentModal = true
  }
}, { immediate: true })
</script>

<template>
  <VDialog
    v-model="appStore.studentSetCurrentStudentModal"
    width="auto"
    max-width="35rem"
    persistent
  >
    <VCard>
      <VCardTitle>
        {{ $t('components.student.set_current_student.select_current_school') }}
      </VCardTitle>
      <VCardText>
        {{ $t('components.student.set_current_student.modal_text') }}

        <VList :disabled="saving" class="switch-student-element switch-student-list border-sm py-0 my-8">
          <template v-for="(student, index) in (studentStore.all_students)" :key="student.id">
            <VListItem
              class="px-6 py-2"
              :prepend-avatar="student.organisation_logo_src || ''"
              :title="student.organisation_name"
              :subtitle="`${student.first_name} ${student.last_name}`"
              @click="selectStudent(student.id)"
            />
            <VDivider v-if="index < (studentStore.all_students?.length || 0) - 1" />
          </template>
        </VList>
      </VCardText>
      <VCardActions class="d-flex justify-space-between ma-2">
        <VBtn
          color="grey"
          variant="outlined"
          class="text-none"
          @click="appStore.studentSetCurrentStudentModal = false"
        >
          {{ i18n.global.t('actions.cancel') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
